import * as zod from 'zod';

import { CaptureConfig } from '../Capture/captureConfig';

const Arguments = zod.object({
  skillId: zod.string(),
  positionListName: zod.string().optional(),
  captureConfig: CaptureConfig.optional(),
});

export default Arguments;
